import { CSSObject } from '@chakra-ui/react';
import overviewBannerDesktop from '@/assets/junglebet/images/backgrounds/overviewBannerDesktop.png';
import overviewBannerMobile from '@/assets/junglebet/images/backgrounds/overviewBannerMobile.png';
import { BannerSchema } from '@/views/account/Overview/components/Banner/styles/Banner.styles';

export const bannerStyles: BannerSchema = {
  buttonDeposit: {
    h: 7,
    fontSize: 'xs',
    px: 3,
  },
};

export const FlexAccountDetails: CSSObject = {
  flexDir: ['column', null, 'row'],
  w: 'full',
  gap: ['1', null, '2'],
  alignItems: ['unset', null, 'center'],
};

export const FlexAccountName: CSSObject = {
  fontSize: 'xl',
  color: 'white',
  fontWeight: 'semibold',
  filter: 'drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.5))',
};

export const FlexBannerContainer: CSSObject = {
  p: '4',
  bg: [`url(${overviewBannerMobile})`, null, `url(${overviewBannerDesktop})`],
  '&&': {
    backgroundSize: 'cover',
    backgroundPosition: ['center top', null, 'right'],
    backgroundRepeat: 'no-repeat',
  },
  borderRadius: 'base',
  gap: ['2', null, 'unset'],
  boxShadow:
    '0px 3px 10px 0px rgba(0, 0, 0, 0.40), 0px 0px 0px 5px rgba(255, 255, 255, 0.30) inset, 0px 0px 0px 2px #FFA902 inset',
};

export const FlexBannerBalanceInner: CSSObject = {
  flex: ['1', null, '0 1 auto'],
};

export const FlexLabel: CSSObject = {
  w: ['full', null, 'unset'],
  flex: '1',
};

export const FlexBalanceBetInfo: CSSObject = {
  px: '3',
  py: '3',
  bg: 'transparent',
  fontFamily: 'CarterOne',
  color: 'white',
  border: '2px',
  borderColor: 'white',
  borderRadius: 'base',
  boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.2)',
  textShadow: '0px 1px 3px rgba(0, 0, 0, 0.40)',
  fontSize: '2xs',
  h: ['7', null, 'full'],
  textTransform: 'uppercase',
  alignItems: 'center',
  justifyContent: 'center',
  flex: ['1', null, 'unset'],
};

export const FlexAccountBalances: CSSObject = {
  flexDir: 'row',
  gap: ['8', null, '6'],
  justifyContent: ['space-between', null, 'unset'],
  filter: 'drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.5))',
};

export const TextButton: CSSObject = {
  alignSelf: 'center',
  color: 'blackAlpha.700',
  fontFamily: 'CarterOne',
};

export const TextAccountBalanceLabel: CSSObject = {
  textTransform: 'uppercase',
  fontSize: 'xs',
  fontWeight: 'bold',
  letterSpacing: 'wider',
  color: 'white',
};

export const TextAccountBalanceBaseUnit = (): CSSObject => ({
  textTransform: 'uppercase',
  fontSize: 'xl',
  fontWeight: 'extrabold',
  color: 'beta.400',
});

export const TextAccountBalanceSubUnit = (): CSSObject => ({
  textTransform: 'uppercase',
  fontSize: 'sm',
  fontWeight: 'extrabold',
  color: 'beta.400',
  opacity: '0.7',
});

export const TextAccountBalanceCurrencySymbol = (): CSSObject => ({
  mt: '0.5',
  mr: '0.5',
  alignSelf: 'flex-start',
  textTransform: 'uppercase',
  fontSize: 'xs',
  fontWeight: 'bold',
  color: 'beta.400',
});

export const FlexButtonContainer: CSSObject = {
  h: ['unset', null, '6'],
  fontSize: '2xs',
  gap: '2',
  flexDir: ['column', null, 'row'],
  filter: 'drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.3))',
};
